
import './App.css';
import React, { useRef,useState,useEffect  } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import ButtonGroup from './buttonGroup.jsx';
import CustomSlider from './mySlider.jsx';
import SelectComponent from './SelectComponent'


function  ChatUI ({ onRequestComplete }) {
  const API_URL_TEST = 'https://api-test.aihear.io';
  const API_URL = 'https://api-prod.aihear.io';

  const [isDisabled, setIsDisabled] = useState(false); // 控制按钮的可用状态

  const handleToggle = () => {
    setIsDisabled(!isDisabled); // 切换按钮的可用状态
  };

  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);

   // 创建ref来控制input之间的自动跳转
  const input1RefOrder = useRef(null);
  const input2RefOrder = useRef(null);
  const input3RefOrder = useRef(null);

  const [part1, setPart1] = useState('');
  const [part2, setPart2] = useState('');
  const [part3, setPart3] = useState('');

  // 创建ref来控制input之间的自动跳转
  const inputRefFavorite = useRef(null);
  const inputRefNeed = useRef(null);

  const [bShowBtn, setShowBtn] = useState(false);
  const [bShowBtn2, setShowBtn2] = useState(false);
  const [bShowBtn3, setShowBtn3] = useState(false);
  const [bShowBtn4, setShowBtn4] = useState(false);
  const [bShowBtn5, setShowBtn5] = useState(false);

  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [channel, setChannel] = useState('');

  // 处理选项更改
  const handleSelectChange = (selectedOption) => {
    setChannel(selectedOption); // 更新父组件中的选中状态
    console.log('option:', selectedOption); // 输出选中结果
  };

  const [favorite, setFavorite] = useState('');
  const [need, setNeed] = useState('');

  const [selectedButton, setSelectedButton] = useState(null);

  const handleSelect = (number) => {
    setSelectedButton(number); // 更新父组件的状态，存储选中的按钮编号
    console.log('rate:', number); // 输出选中结果
  };

  // 处理按键事件（特别是删除键）
  const handleKeyDown = (e, part, setPart, prevInputRef) => {
    if (e.key === 'Backspace' && part === '') {
      if (prevInputRef) {
        prevInputRef.current.focus();
      }
    }
  };

   // 处理输入值并确保只能输入数字
   const handleInputChangeOrder = (e, setPart, maxLength, nextInputRef) => {
    const value = e.target.value;
    setShowBtn3(false);
    if (/^\d*$/.test(value) && value.length <= maxLength) {  // 只允许数字输入
      setPart(value);
      if (value.length === maxLength && nextInputRef) {  // 输入达到最大长度时，自动跳转到下一个输入框
        nextInputRef.current.focus();
      }
    }
  };

  const handlePaste = (e) => {
    setShowBtn3(false);
    const pastedData = e.clipboardData.getData('Text').trim();
    e.preventDefault();// 阻止默认的粘贴操作

    const newStr = pastedData.replace(/-/g, '');
    // 检查粘贴的数据长度是否为 17
    if (/^\d{17}$/.test(newStr)) {
      setPart1(newStr.slice(0, 3));
      setPart2(newStr.slice(3, 10));
      setPart3(newStr.slice(10, 17));
      // if (input3RefOrder.current) {
      //   input3RefOrder.current.setSelectionRange(7, 7);
      // }
    } else {
      toast.error("Please enter the 17-digit order number.", {
        position: 'top-center' // 在窗口中间显示
      })
    }
  };

  function callbackEmail (json) {
    try {
      let jsonObject = window.JSON.parse(json);
      console.log(jsonObject)
      if(jsonObject.code === 200){
        // toast.success("Your feedback sent successfully", {
        //   position: 'top-center' // 在窗口中间显示
        // })
        onRequestComplete()
        handleToggle()
      }
      else{
        console.log('send feedback Information failed: ', jsonObject.message)
        toast.error('send feedback Information failed: '+jsonObject.message, {
          position: 'top-center' // 在窗口中间显示
        })
        handleToggle()
      }
    } catch (error) {
      console.error('Error during send feedback Information: ', error);
      toast.error('Error during send feedback Information: '+ error, {
        position: 'top-center' // 在窗口中间显示
      })
      handleToggle()
    }
  };

  const sendUser = async ( callback) =>
    {
      let httpRequest = new XMLHttpRequest();
      //httpRequest.open('POST', `${API_URL_TEST}/infonew/add`, true);//测试环境
      //httpRequest.open('POST', `${API_URL}/infonew/add`, true);//正式环境
      httpRequest.open('POST', `${API_URL}/info/add`, true);//正式环境
      // 设置请求头，表示发送的数据是 JSON 格式
      httpRequest.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      // 准备发送的数据
      // console.log('orderNumber:', part1 + '-' + part2 + '-' + part3); // 输出选中结果
      var data = JSON.stringify({
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        orderSource: channel,
        favoriteFt: favorite,
        rating: selectedButton,
        improvements: need,
        // orderNum: part1 + '-' + part2 + '-' + part3,
        nps: selectedLevel.toString()
      });
      console.log('data:', data); // 输出选中结果



      httpRequest.send(data);
  
      httpRequest.onreadystatechange = function () {//
        if (httpRequest.readyState === 4 && httpRequest.status === 200) {
          let json = httpRequest.responseText;
          callback(json);
        }
      };
    }
  
  useEffect(() => {
  }, []); // 空数组表示只在组件挂载时运行一次
  
  const handleClick = () => {
    if(inputRef.current)
      inputRef.current.value = '';
    setShowBtn(false);
    setName('');
  };

  const handleClick2 = () => {
    if(inputRef2.current)
      inputRef2.current.value = '';
    setShowBtn2(false);
    setPhoneNumber('');
  };

  const handleClick3 = () => {
    if(inputRef3.current)
      inputRef3.current.value = '';
    setShowBtn3(false);
    setEmail('');
  };

  const handleClick4 = () => {
    if(inputRefFavorite.current){
      inputRefFavorite.current.value = '';
    }
    setFavorite('')
    setShowBtn4(false);
  };

  const handleClick5 = () => {
    if(inputRefNeed.current)
      inputRefNeed.current.value = '';
    setShowBtn5(false);
    setNeed('');
  };

  const handleBlur = (event,inputRefTemp) => {
    setTimeout(() => {
      setShowBtn(false);
      setShowBtn2(false);
      setShowBtn3(false);
      setShowBtn4(false);
      setShowBtn5(false);
    }, 500);
  };


  const handleClickEmail = () => {
    if(channel === ''){
      toast.error("Please select a valid purchase channel.", {
        position: 'top-center' // 在窗口中间显示
      })
      inputRef.current.focus();
      return;
    }
    if(name === ''){
      toast.error("Please enter a valid name.", {
        position: 'top-center' // 在窗口中间显示
      })
      inputRef.current.focus();
      return;
    }

    if(phoneNumber === ''){
      toast.error("Please enter a valid phone number.", {
        position: 'top-center' // 在窗口中间显示
      })
      inputRef2.current.focus();
      return;
    }
    console.log(phoneNumber)

    if(email === ''){
      toast.error("Please enter a valid email address.", {
        position: 'top-center' // 在窗口中间显示
      })
      inputRef3.current.focus();
      return;
    }

    const isValidEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(String(email).toLowerCase());
    if(!isValidEmail){
      toast.error("The email format is incorrect.", {
        position: 'top-center' // 在窗口中间显示
      })
      inputRef3.current.focus();
      return;
    }

    if(selectedButton === null){
      toast.error("Please select a rate star.", {
        position: 'top-center' // 在窗口中间显示
      })
      window.scrollTo(0, 0); // 滚动到页面顶部
      return;
    }

    // if(part1 === '' || part2 === '' || part3 === '' || part1.length !== 3 || part2.length !== 7 || part3.length !== 7){
    //   toast.error("Please enter a valid order number.", {
    //     position: 'top-center' // 在窗口中间显示
    //   })
    //   window.scrollTo(0, 0); // 滚动到页面顶部
    //   return;
    // }

    handleToggle()

    sendUser(callbackEmail);
  };

  // 处理输入框值变化
  const handleInputChange = (event) => {
    setShowBtn(true);
    setName(event.target.value);
  };

  const handleInputChange2 = (event) => {
    setShowBtn2(true);
    const inputValue = event.target.value
    setPhoneNumber(inputValue);
  };

  const handleInputChange3 = (event) => {
    setShowBtn3(true);
    setEmail(event.target.value);
  };

  const handleInputChange4 = (event) => {
    setShowBtn4(true);
    setFavorite(event.target.value);
  };

  const handleInputChange5 = (event) => {
    setShowBtn5(true);
    setNeed(event.target.value);
  };

  const [selectedLevel, setSelectedLevel] = useState(9); // 保存用户选择的等级

  const handleSliderChange = (value) => {
    setSelectedLevel(value); // 更新父组件的状态
  };

  return (
    
    <div className="container">

      <div className='container-top-left'>

      <div className='container-top-left-white'>
        <div className='div-grey-container-center div-margin-top-60 div-mid-text'>
        Help Us Improve
        
        </div>
        <div className='div-left-text div-margin-top-60'>
          Where did you purchase our product?
        </div>
        <div className='div-grey-container-relative'>
          <SelectComponent onSelectChange={handleSelectChange} /> 
        </div>

        <div className='div-left-text div-margin-top-60'>
        How would you like to rate ELEHEAR Beyond from 1 to 5?
        </div>
        <div className='sub-text'>
        with 1 being the lowest and 5 the highest
        </div>

        <ButtonGroup onSelect={handleSelect} />

        <div className='div-left-text div-margin-top-60'>
        What’s your favorite feature of the product?
        </div>
        <div className='div-grey-container-relative'>
          <input ref={inputRefFavorite} onChange={handleInputChange4} 
          onBlur={(e) => handleBlur(e, inputRefFavorite)} 
          className='input-email'
          >
          </input>
          { bShowBtn4 &&
            <button onClick={handleClick4} className='delete-btn'></button>
          }
        </div>

        <div className='div-left-text div-margin-top-60'>
        What improvements do you think the product still needs?
        </div>
        <div className='div-grey-container-relative-height'>
          
          <textarea
            className='textarea-input'
            ref={inputRefNeed}
            onBlur={(e) => handleBlur(e, inputRefNeed)} 
            onChange={handleInputChange5} 
          />
          { bShowBtn5 &&
            <button onClick={handleClick5} className='clear-button'></button>
          }
        </div>

        <div className='div-left-text div-margin-top-60'>
        How likely are you to recommend our product to friends and family?
        </div>
        <div className='sub-text'>
        with 1 being the lowest and 10 the highest
        </div>

        <CustomSlider onChange={handleSliderChange} />
        
        </div>
        <div className="footer-placeholder"></div>
        <div className="footer-placeholder"></div>
      </div>

      <div className='container-top-left-grey'>
        <div className='div-mid-text div-margin-top-60'>
          Please fill in the info below
        </div>

        <div className='div-left-text div-margin-top-60'>
        User Name
        </div>
        <div className='div-grey-container-relative-white'>
          <input ref={inputRef} onChange={handleInputChange} 
          onBlur={(e) => handleBlur(e, inputRef)} 
          className='input-email-white' placeholder="Please enter your name"
          >
          </input>
          { bShowBtn &&
            <button onClick={handleClick} className='delete-btn'></button>
          }
        </div>

        <div className='div-left-text div-margin-top-60'>
        Phone Number
        </div>
        <div className='div-grey-container-relative-white'>
          <input ref={inputRef2} onChange={handleInputChange2} 
          onBlur={(e) => handleBlur(e, inputRef2)} 
          className='input-email-white' placeholder="Please enter mobile number"
          >
          </input>
          { bShowBtn2 &&
            <button onClick={handleClick2} className='delete-btn'></button>
          }
        </div>

        <div className='div-left-text div-margin-top-60'>
        Email Address
        </div>
        <div className='div-grey-container-relative-white'>
          <input ref={inputRef3} onChange={handleInputChange3} 
        
          onBlur={(e) => handleBlur(e, inputRef3)} 
          className='input-email-white' placeholder="Please enter email address"
          >
          </input>
          { bShowBtn3 &&
            <button onClick={handleClick3} className='delete-btn'></button>
          }
        </div>

        {/* <div className='div-left-text div-margin-top-60'>
          Order Number
        </div> 
        <div className='input-container-sub'>
          
          <input
            ref={input1RefOrder}
            type="number"
            inputMode="numeric"  // 设置为数字模式
            value={part1}
            onChange={(e) => handleInputChangeOrder(e, setPart1, 3, input2RefOrder)}  // 第一部分最大长度为5
            onKeyDown={(e) => handleKeyDown(e, part1, setPart1, null)} 
            onPaste={handlePaste}
            className="input-field-small no-arrows"
            maxLength="3"
          />
          <span className="dash">-</span>
          <input
            ref={input2RefOrder}
            type="number"
            inputMode="numeric"  // 设置为数字模式
            value={part2}
            onChange={(e) => handleInputChangeOrder(e, setPart2, 7, input3RefOrder)}  // 第二部分最大长度为7
            onKeyDown={(e) => handleKeyDown(e, part2, setPart1, input1RefOrder)} 
            onPaste={handlePaste}
            className="input-field  no-arrows"
            maxLength="7"
          />
          <span className="dash">-</span>
          <input
            ref={input3RefOrder}
            type="number"
            inputMode="numeric"  // 设置为数字模式
            value={part3}
            onChange={(e) => handleInputChangeOrder(e, setPart3, 7)}  // 第三部分最大长度为5
            onKeyDown={(e) => handleKeyDown(e, part3, setPart1, input2RefOrder)} 
            onPaste={handlePaste}
            className="input-field  no-arrows"
            maxLength="7"
          />

          { bShowBtn4 &&
            <button onClick={handleClick4} className='delete-btn'></button>
          }
        </div> */}

        <div className='sub-text div-margin-top-60'>
          By submitting, you agree to our
          
          <a href="https://api-prod.aihear.io/privacy_policy.html" target="_blank" rel="noopener noreferrer" style={{color: 'blue', textDecoration: 'none'}}>
          <span style={{color: 'rgba(240, 86, 39, 1)'}}> Privacy Policy
          </span>
          </a>
          . Review our data practices here.
        </div>

          <button disabled={isDisabled} className='share-button-link' onClick={handleClickEmail}>
          Submit
          </button>
      </div>

      <div className="footer-placeholder"></div>

      <Toaster/>
    </div>
  );
};


export default ChatUI;
